;(function () {
  'use strict'

  angular
    .module('contrast.settings.permission', [
      'ngRoute',
      'ngAnimate',
      'route-segment',
      'view-segment',
      'ui.bootstrap',
      'xeditable'
    ])
    .controller('UserPermissionsCtrl', UserPermissionsCtrl)

  function UserPermissionsCtrl(
    $scope,
    $uibModal,
    $q,
    RoleFactory,
    OrganizationFactory,
    groupService,
    ErrorService,
    ROLES,
    ROLE_ADMIN,
    ROLE_RULES_ADMIN,
    ROLE_EDIT,
    ROLE_VIEW
  ) {
    'ngInject'

    function init() {
      var promises = []
      promises.push(getRoles())
      promises.push(getOrgInfo())

      $q.all(promises).then(function () {
        _getApps(0)
      })
    }

    var _searchKeywords

    angular.extend($scope, {
      roles: ROLES,
      data: {
        orgName: '',
        numPerLoad: 25,
        loadPromise: null,
        busy: false,
        textFiltered: false,
        records: [],
        roles: {
          all: [],
          orgRole: '',
          appRole: ''
        },
        apps: {
          displayed: [],
          total: 0
        },
        searchKeywords: function (newSearchKeywords) {
          if (!arguments.length) {
            return _searchKeywords
          }

          if (newSearchKeywords !== _searchKeywords) {
            _searchKeywords = newSearchKeywords

            _clearApps()
            _getApps(0)
          }
          $scope.data.textFiltered = !!_searchKeywords
          return _searchKeywords
        }
      }
    })

    //Functions
    angular.extend($scope, {
      loadByScroll: function () {
        if (
          $scope.data.apps.displayed.length == $scope.data.apps.total ||
          $scope.data.apps.total == 0
        ) {
          return
        }

        _getApps($scope.data.apps.displayed.length)
      },

      //Modals
      viewPermissions: function (role, isOrgRole) {
        var template
        if (isOrgRole) {
          template =
            'views/permissions/organizational/organization-permissions.html'
        } else {
          template =
            'views/permissions/organizational/application-permissions.html'
        }
        var modalInstance = $uibModal.open({
          templateUrl: template,
          controller: 'ModalPermissionsDetailsCtrl',
          windowClass: 'permission-modal',
          size: 'lg-md',
          resolve: {
            role: function () {
              return ROLES[role]
            },
            /*TODO i18n-050*/
            permissionRoles: function () {
              switch (ROLES[role]) {
                case ROLES.admin:
                  return ROLE_ADMIN
                case ROLES.rules_admin:
                  return ROLE_RULES_ADMIN
                case ROLES.edit:
                  return ROLE_EDIT
                case ROLES.view:
                  return ROLE_VIEW
                default:
                  return ''
              }
            }
          }
        })

        modalInstance.result.then(function () {})
      }
    })

    function _getApps(offset) {
      $scope.data.busy = true

      return OrganizationFactory.getApplicationRoles(
        offset,
        $scope.data.numPerLoad,
        _searchKeywords
      ).then(
        function (response) {
          var view = groupService.createPermissionView(
            response.data.applications,
            $scope.data.roles.all
          )

          $scope.data.apps.displayed.push(...view.apps)
          $scope.data.apps.total = response.data.total

          $scope.data.roles.orgRole = response.data.org_role

          const appRole = response.data.app_role
          $scope.data.roles.appRole = appRole

          $scope.appRole = appRole.toUpperCase()

          $scope.data.busy = false
        },
        function (response) {
          ErrorService.processError(response)
          $scope.data.busy = false
        }
      )
    }

    function _clearApps() {
      $scope.data.apps.displayed = []
    }

    function getRoles() {
      if ($scope.data.roles.all.length == 0) {
        return RoleFactory.getRoles().then(
          function (response) {
            $scope.data.roles.all = response.data.groups
            angular.forEach($scope.data.roles.all, function (role, index) {
              role.value = index
            })
          },
          function (response) {
            ErrorService.processError(response)
          }
        )
      } else {
        return $q.when($scope.data.roles.all)
      }
    }

    function getOrgInfo() {
      return OrganizationFactory.getOrganization().then(
        function (response) {
          $scope.data.orgName = response.data.organization.name
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    init()
  }
})()
